import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const BulkUploadQuestionsSlice = createSlice({
    name: "BulkUploadQuestionsSlice",
    initialState: {} as IReduxState<any>,
    reducers: {
        bulkUploadQuestions: (state, _: PayloadAction<File>) => {
            state.isLoading = true;
        },
        successBulkUploadQuestions: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureBulkUploadQuestions: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearBulkUploadQuestionsResponse: (state) => {
            state.data = {};
            state.isLoading = false;
        },
    },
});

export const {
    bulkUploadQuestions,
    successBulkUploadQuestions,
    failureBulkUploadQuestions,
    clearBulkUploadQuestionsResponse,
} = BulkUploadQuestionsSlice.actions;

export default BulkUploadQuestionsSlice.reducer;
